import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAdminLoggedIn } from "@/lib/api";

/**
 * ProtectedRoute
 * - Sadece auth kontrolü yapar
 * - children render ETMEZ
 * - Outlet pattern kullanır
 */
const ProtectedRoute = () => {
    const location = useLocation();
    const isAuthenticated = isAdminLoggedIn();

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/admin/login"
                state={{ from: location }}
                replace
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;